export const NavbarData = ["Products", "Projects", "Contact", "About Us"];
